interface IconProps {
  className?: string;
}

export const RocketIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 6C24 6 36 10 36 22C36 28 32 36 24 42C16 36 12 28 12 22C12 10 24 6 24 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle
      cx="24"
      cy="20"
      r="4"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M18 36L12 42M30 36L36 42"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const LightningIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 6L14 26H24L22 42L34 22H24L26 6Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const TargetIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="24"
      cy="24"
      r="18"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="24"
      cy="24"
      r="12"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="24"
      cy="24"
      r="6"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M42 6L32 16M24 24L32 16M32 16H38M32 16V10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RobotIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="10"
      y="16"
      width="28"
      height="22"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="24"
      cy="10"
      r="3"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M24 13V16M16 24H18M30 24H32M18 32H22M26 32H30"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10 28H6M42 28H38M10 32H6M42 32H38"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const PluginIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 10V6M30 10V6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="14"
      y="10"
      width="20"
      height="18"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M24 28V42M18 36H30"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M20 16H28M20 20H28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ImageIcon = ({ className = '' }: IconProps) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6"
      y="10"
      width="36"
      height="28"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="16"
      cy="20"
      r="3"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M6 32L14 24L22 32L32 22L42 32V36C42 37.1046 41.1046 38 40 38H8C6.89543 38 6 37.1046 6 36V32Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const getPortfolioIcon = (iconType: string) => {
  const iconClass = "portfolio-icon-svg";
  
  switch (iconType) {
    case 'rocket':
      return <RocketIcon className={iconClass} />;
    case 'lightning':
      return <LightningIcon className={iconClass} />;
    case 'target':
      return <TargetIcon className={iconClass} />;
    case 'robot':
      return <RobotIcon className={iconClass} />;
    case 'plugin':
      return <PluginIcon className={iconClass} />;
    case 'image':
      return <ImageIcon className={iconClass} />;
    default:
      return <TargetIcon className={iconClass} />;
  }
};
